import React from 'react';
import styles from './ProfessionalCard.module.scss';
import { useProfessionalCard } from './hooks/useProfessionalCard';
import { ProfessionalCardProps } from './types/Professional.types';
import { useTranslation } from 'react-i18next';

const ProfessionalCard: React.FC<ProfessionalCardProps> = ({ professional, uid }) => {
  const {
    isPlaying,
    videoData,
    dimColor,
    handleCardClick,
    handlePlayClick
  } = useProfessionalCard(professional, uid);

  const { isVideo, isEmbed, finalVideoUrl } = videoData;
  const { t } = useTranslation();

  return (
    <article 
      className={styles['grid-card']} 
      style={{ '--dimension-color': dimColor } as React.CSSProperties}
      onClick={handleCardClick}
    >
      <div 
        className={styles['grid-card__media']} 
        style={{ backgroundImage: isPlaying ? 'none' : `url(${professional.image})` }}
      >
        {isVideo && isPlaying ? (
          <div className={styles['grid-card__video-container']}>
            {isEmbed ? (
              <iframe src={finalVideoUrl} frameBorder="0" allowFullScreen title="Video Profile" />
            ) : (
              <video src={finalVideoUrl} controls autoPlay onClick={(e) => e.stopPropagation()} />
            )}
          </div>
        ) : (
          isVideo && (
            <button 
              className={styles['grid-card__video-trigger']} 
              type="button" 
              aria-label="Reproducir video de presentación"
              onClick={handlePlayClick}
            ></button>
          )
        )}
      </div>

      <div className={styles['grid-card__body']}>
        <div className={styles['grid-card__copy']}>
          <h3 className={styles['grid-card__name']}>{professional.name}</h3>
          <p className={styles['grid-card__role']}>
            {professional.profession || '\u00A0'}
          </p>

          <div className={styles['grid-card__specialties']}>
            <svg
              className={styles['grid-card__specialties-icon']}
              viewBox="0 0 20 20"
              fill="none"
              aria-hidden="true"
            >
              <path
                d="M9.2 2.4H3.9a1.5 1.5 0 0 0-1.5 1.5v5.3a1.5 1.5 0 0 0 .44 1.06l7.5 7.5a1.5 1.5 0 0 0 2.12 0l5.33-5.33a1.5 1.5 0 0 0 0-2.12l-7.53-7.5A1.5 1.5 0 0 0 9.2 2.4Z"
                fill="#8B9A92"
              />
              <circle cx="6.2" cy="6.2" r="1.35" fill="#F7F5F1" />
            </svg>
            <div className={styles['grid-card__specialties-list']}>
              <span className={styles['grid-card__specialty-chip']} title={professional.specialty}>
                <span className={styles['grid-card__specialty-text']}>{professional.specialty}</span>
              </span>
              {professional.additionalSpecialtiesCount ? (
                <span className={styles['grid-card__specialty-more']}>
                  +{professional.additionalSpecialtiesCount}
                </span>
              ) : null}
            </div>
          </div>
        </div>
        <div className={styles['grid-card__msp-row']}>
          {professional.isMspVerified && (
            <div className={styles['grid-card__msp']}>
              {t('landing.professionalsList.mspVerified', 'Registro MSP verificado')}
            </div>
          )}
        </div>

        <button onClick={handleCardClick} className={styles['grid-card__cta']}>{t('landing.professionalsList.viewProfile', 'Ver perfil')}</button>
      </div>
    </article>
  );
};

export default ProfessionalCard;